/**
 * Enum representing the different types of forms that can be created
 */
export enum FormType {
  Application = 'Application',
  Assessment = 'Assessment',
  EligibilityQuestionnaire = 'EligibilityQuestionnaire',
  PreAssessment = 'PreAssessment',
  Survey = 'Survey',
  UserProfile = 'UserProfile'
}

/**
 * Interface representing a form type option for display
 */
export interface FormTypeOption {
  /** The form type enum value */
  type: FormType;
  /** Display label for the form type */
  label: string;
  /** Description of what this form type is used for */
  description: string;
  /** Icon class (PrimeNG or Material) */
  icon: string;
  /** Icon type: 'prime' or 'material' */
  iconType: 'prime' | 'material';
}

/**
 * Predefined form type options with their display information
 */
export const FORM_TYPE_OPTIONS: FormTypeOption[] = [
  {
    type: FormType.Application,
    label: 'Application',
    description: 'Create an application form for submissions and reviews',
    icon: 'description',
    iconType: 'material'
  },
  {
    type: FormType.Assessment,
    label: 'Assessment',
    description: 'Create an assessment form for evaluations',
    icon: 'assignment',
    iconType: 'material'
  },
  {
    type: FormType.EligibilityQuestionnaire,
    label: 'Eligibility Questionnaire',
    description: 'Create a questionnaire to determine eligibility',
    icon: 'checklist',
    iconType: 'material'
  },
  {
    type: FormType.PreAssessment,
    label: 'Pre-assessment',
    description: 'Create a pre-assessment form for initial screening',
    icon: 'fact_check',
    iconType: 'material'
  },
  {
    type: FormType.Survey,
    label: 'Survey',
    description: 'Create a survey for collecting feedback and data',
    icon: 'poll',
    iconType: 'material'
  },
  {
    type: FormType.UserProfile,
    label: 'User Profile',
    description: 'Create a user profile form for capturing user details',
    icon: 'person',
    iconType: 'material'
  }
];

